import React from 'react';
import { Title } from 'rizzui';
import cn from '../../utils/classNames';
import Breadcrumb from './breadcrumb';

export type PageHeaderTypes = {
    title: string | React.ReactNode;
    breadcrumb?: { name: string; href?: string }[];
    className?: string;
    isSticky?: boolean;
};

export default function PageHeader({ title, breadcrumb, children, className, isSticky = true }: React.PropsWithChildren<PageHeaderTypes>) {
    return (
        <header className={cn('py-2 mb-4 pt-4 @container top-[75px] lg:mb-0 bg-white z-[70] ', className, isSticky ? 'sticky ' : '')}>
            <div className="flex flex-col @lg:flex-row @lg:items-center @lg:justify-between">
                <div>
                    <Title
                        as="h2"
                        className="mb-2 text-[22px] lg:text-2xl 4xl:text-[26px]"
                    >
                        {title}
                    </Title>

                    <Breadcrumb separator="" separatorVariant="circle" className={cn("flex-wrap", { "hidden": !breadcrumb })}>
                        {breadcrumb?.map((item) => (
                            <Breadcrumb.Item
                                key={item.name}
                                {...(item?.href && { href: item?.href })}
                            >
                                {item.name}
                            </Breadcrumb.Item>
                        ))}
                    </Breadcrumb>
                </div>

                {children}
            </div>
        </header>
    );
}